/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_LabelInputs */

const en_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder Name`)
};

const fr_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du dossier`)
};

const de_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnername`)
};

const it_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome cartella`)
};

const ru_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название папки`)
};

const es_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la carpeta`)
};

const zh_cn2_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹名称`)
};

const ja_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ名`)
};

const hi_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर का नाम`)
};

const pt_pt2_explorer_display_new_folder_label = /** @type {(inputs: Explorer_Display_New_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da pasta`)
};

/**
* | output |
* | --- |
* | "Folder Name" |
*
* @param {Explorer_Display_New_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_label = /** @type {((inputs?: Explorer_Display_New_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_label(inputs)
	if (locale === "de") return de_explorer_display_new_folder_label(inputs)
	if (locale === "it") return it_explorer_display_new_folder_label(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_label(inputs)
	if (locale === "es") return es_explorer_display_new_folder_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_label(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_label(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_label(inputs)
	return en_explorer_display_new_folder_label(inputs)
});